import { cookieNames, platform, userAgents, vendors } from 'utils/constants';

const getAuthDataFromWebview = (webviewCookieData) => {
  if(!webviewCookieData){
    return;
  }
  const doconPageData = webviewCookieData?.pageData?.doconParams;
  const accessToken = doconPageData?.accessToken;
  const userID = doconPageData?.userID;
  return {
    accessToken,
    userID,
  };
};

export const checkIsWebview = (cookies) => {
  let _isWebView = !!cookies[cookieNames.WEBVIEW_COOKIE]?.pageData?.doconParams;
  return isPharmeasyWebView(cookies) && _isWebView;
};

export const isPharmeasyWebView = (cookies) => (
  cookies[cookieNames.PHONE_PLATFORM_COOKIE] === platform?.android ||
  cookies[cookieNames.PHONE_PLATFORM_COOKIE] === platform?.ios ||
  cookies[cookieNames.VENDOR_COOKIE] === vendors?.pharmeasy
);

export const isPeIosWebview = (vendor, userAgent) =>
  vendor === vendors.pharmeasy && userAgent?.includes(userAgents.ios);

function getCallbackData(action, rawData) {
  let appendedCommonPayloadWebview = rawData;
  // if (action === 'triggerEvents') {
  //   appendedCommonPayloadWebview = appendCommonPayloadWebview(rawData);
  // }
  return JSON.stringify(appendedCommonPayloadWebview) || '';
}

export function emitEvent(action, rawData) {
  const data = getCallbackData(action, rawData);
  try {
    if (window.Android?.[action]) {
      if (data) {
        window.Android[action](data);
      } else {
        window.Android[action]();
      }
      return true;
    }
    if (window.webkit?.messageHandlers?.[action]) {
      if (data) {
        window.webkit.messageHandlers[action].postMessage(data);
      } else {
        window.webkit.messageHandlers[action].postMessage('');
      }
      return true;
    }
    return false;
  } catch (e) {
    return false;
  }
}

export const exposeWebviewMethods = ( setWebviewData = null) => {
  if (setWebviewData) {
    window.setWebviewData = data => setWebviewData(data);
  }

  // disable native control over WebView navigation
  toggleWebViewBackPress({ enableWebViewGoBack: false });

  window.onWebViewBackPress = () => {
    // if (window.history?.state?.id > 0) {
    //   return window.history.back();
    // }

    window.history.back();
  };
};

export const toggleNativeLoader = params => {
  emitEvent('toggleNativeLoader', params);
};

export const toggleNativeHeader = params => emitEvent('toggleNativeHeader', params);

export const toggleWebViewBackPress = params => emitEvent('toggleBackPress', params);

export const dismissWebView = () => emitEvent('onWebviewDismiss');

export default getAuthDataFromWebview;
